import {z} from "zod";
import {CoordinateModel, DEFAULT_COORDINATE} from "./CoordinateModel";
import {COMPANY_STATUS_KEY_TYPE, CORPORATION_KEY_TYPE} from "./common/enum";

const schema = z.object({
	id: z.string(),
	name: z.string().nullable().default(""),
	address: z.string().nullable().default(""),
	telephone: z.string().nullable().default(""),
	corporationName: z.string().nullable().default(""),
	corporationType: CORPORATION_KEY_TYPE.nullable().default("NONE"),
	companyStatus: COMPANY_STATUS_KEY_TYPE.nullable().default("UNKNOWN"),
	coordinate: CoordinateModel.model,
	//new
	managerName: z.string().nullable().default(""),
	registeredDate: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const PointModel = {schema, model};
export type IPointModel = z.infer<typeof PointModel.model>;
export const DEFAULT_POINT: IPointModel = {
	id: "",
	name: "",
	address: "",
	telephone: "",
	managerName: "",
	registeredDate: null,
	corporationName: "",
	corporationType: "NONE",
	companyStatus: "UNKNOWN",
	coordinate: DEFAULT_COORDINATE
};
